import {
  CORPORATE_SITEURL,
  SITENAME,
  APP_LOGIN_SITEURL,
  APP_FRONT_SITEURL,
} from "@/constants/site";
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router/router";
import store from "@/store/store";
import "@/filters";
import "@/assets/css/style.scss";

// Swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
// require styles
import "swiper/dist/css/swiper.css";
// Vue.head
import VueHead from "vue-head";

Vue.use(VueAwesomeSwiper);
// Vue.use(typist);
Vue.use(VueHead);

Vue.prototype.$constants = {
  corporateSiteUrl: CORPORATE_SITEURL,
  siteName: SITENAME,
  loginSiteUrl: APP_LOGIN_SITEURL,
  frontSiteUrl: APP_FRONT_SITEURL,
};
Vue.config.productionTip = false;

// v-focusで要素にフォーカスを当てる
Vue.directive("focus", {
  inserted(el, binding, vnode) {
    // v-focus="false"の時はフォーカス当てない
    if (binding.hasOwnProperty("value") && !binding.value) {
      return;
    }
    el.focus();
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
